import React from "react";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface DeleteDraftProps {
  langBase: string;
  permission: string;
  isActionAvailable: boolean;
  onClick: () => void;
}

const DeleteDraft: React.FC<DeleteDraftProps> = ({
  langBase,
  permission,
  isActionAvailable,
  onClick,
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      permission={permission}
      isActionAvailable={isActionAvailable}
      labelKey="delete-draft-button"
      testId="delete-draft"
      variant="text"
      onClick={onClick}
    />
  );
};
export default DeleteDraft;
